export const runSummaryStyles = {
  root: {
    mb: 3,
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: { xs: 'column', lg: 'row' },
    gap: 1,
    mb: 2,
  },
  filterGrid: {
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      sm: 'repeat(2, minmax(0, 1fr))',
      md: 'repeat(3, minmax(0, 1fr))',
      lg: 'minmax(180px, 1fr) minmax(180px, 1fr) minmax(180px, 1fr) minmax(210px, 1fr) minmax(210px, 1fr) 132px',
    },
    gap: 1,
    alignItems: 'stretch',
    width: '100%',
  },
  filterControl: {
    minWidth: 0,
    width: '100%',
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: '0 8px 24px rgba(15, 23, 42, 0.04)',
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
      '&:hover fieldset': {
        borderColor: 'custom.terminalBg',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'primary.main',
      },
    },
    '& .MuiSelect-select': {
      minHeight: '1.4375em',
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: 'primary.main',
    },
  },
  resetButton: {
    color: 'primary.main',
    borderColor: 'primary.main',
    textTransform: 'none',
    fontWeight: 700,
    minHeight: 40,
    width: '100%',
    bgcolor: 'background.paper',
    '&:hover': {
      borderColor: 'primary.main',
      backgroundColor: 'action.hover',
    },
  },
  errorAlert: {
    mb: 2,
  },
  loadingRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    mb: 2,
    color: 'text.secondary',
  },
  metricGrid: {
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      sm: 'repeat(2, minmax(0, 1fr))',
      lg: 'repeat(5, minmax(0, 1fr))',
    },
    gap: 2,
    mb: 2,
  },
  metricTooltipWrap: {
    display: 'block',
    width: '100%',
  },
};
